import { useAppSelector } from '~/store/store';
import { getListFlowValueGuideData } from '~/store/listFlow/slices/info';
import { useQuery } from '@tanstack/react-query';
import { fetchNewValueGuideCalculation } from '~/api/valueGuide';
import { UseQueryResult } from '@tanstack/react-query';
import { RailsValueGuideResponse } from '~/typings/services/rails/responses';

export default function useListFlowValueGuide(): UseQueryResult<
  RailsValueGuideResponse['meta']
> {
  const key = useAppSelector(getListFlowValueGuideData);

  return useQuery(
    ['list-flow-value-guide', key],
    () => fetchNewValueGuideCalculation(key),
    {
      staleTime: Infinity,
      select: d => d.meta,
      keepPreviousData: true,
    },
  );
}
